import type { GuardiansType } from "@/api_types/school";
import FetchService from "@/services/fetch.service";
import { asyncComputed } from "@/utils/asyncComputed";
import { sort } from "@/utils/sort";
import { defineStore } from "pinia";

export const useParents = defineStore("directory/parents", {
  state: () => {
    return {
      parents: asyncComputed(
        async (controller) => {
          const res = (await FetchService.fetchData(
            "/guardians",
            "get",
            undefined,
            undefined,
            controller
          )) as GuardiansType;

          return sort(res || [], (i) => i.firstname + i.lastname);
        },
        [],
        undefined,
        false,
        []
      )
    };
  },
  actions: {
    async getParent(uid: string) {
          const res = await FetchService.fetchData(`/guardians/${uid}`, "get");
          return res;
        },
    async attach(parent_uid: string, relationship: string, uid: string) {
          const res = await FetchService.fetchData(`/guardians/${parent_uid}/attach`, "put", {
            [relationship]: uid
          });
          return res;
        },
    async detach(parent_uid: string, relationship: string, uids: string | string[]) {
      const payload = Array.isArray(uids) ? { [relationship]: uids } : { [relationship]: [uids] };
      const res = await FetchService.fetchData(`/guardians/${parent_uid}/detach`, "put", payload);
      return res;
    },
    async linkParentChildTeacher(children_uid, parent_uid, teacher_uid?: string) {
      const res = await FetchService.fetchData(`/guardians/${parent_uid}/attach`, "put", {
        children_uid,
        teacher_uid
      });
      return res;
    },
    async deleteParentChildTeacherRelation(children_uid, parent_uid, teacher_uid?: string) {
      const res = await FetchService.fetchData(`/guardians/${parent_uid}/detach`, "put", {
        children_uid,
        teacher_uid
      });
      return res;
    },
    async resetPassword(parent_uid, password){
      const res = await FetchService.fetchData(`/guardians/${parent_uid}/resetPassword`, "put",{"password":password});
      return res;
    },
    async updateParent(parent_uid, parentData: Partial<GuardiansType[number]>) {
      const res = await FetchService.fetchData(`/guardians/${parent_uid}`, "put", parentData);
      if (res?.firstname) {
        this.parents.data.forEach((g) => {
          if (g.uid === parent_uid) Object.assign(g, res);
        });
        return true;
      }
      return false;
    },
    async createParent(parentData: Partial<GuardiansType[number]>) {
      const res = await FetchService.fetchData(`/guardians`, "post", parentData);
      if (res?.uid) {
        res.deleted = false;
        this.parents.data = sort([...this.parents.data, res], (i) => i.firstname + i.lastname);
        return true;
      }
      return false;
    }
  }
});

export default useParents;
